import classnames from 'classnames';
import React from 'react';
import './position-tip.less';
import { useFramework } from '@/framework';
import { useLocaleStore } from '@/i18n';
import { REFERENCE_LINE_DIRECTION } from '../constants';
import { useReferenceLinesState } from '../states/reference-lines-state';

type PositionTipProps = {};

const clamp = (value: number, min: number, max: number) => {
    return Math.max(min, Math.min(value, max));
};

const PositionTip: React.FC<PositionTipProps> = () => {
    const framework = useFramework();
    const referenceLinesState = useReferenceLinesState();
    const { $t } = useLocaleStore();
    const tooltipPosition = referenceLinesState((state) => state.tooltipPosition);
    const draggingLine = referenceLinesState((state) => state.draggingLine);
    const rulerBarSize = referenceLinesState((state) => state.rulerBarSize);
    if (!draggingLine) return null;

    const containerRect = framework.service.editor.getBoundingClientRect();
    if (!containerRect) return null;

    const { position, direction } = draggingLine;
    const isVertical = direction === REFERENCE_LINE_DIRECTION.VERTICAL;
    const isHorizontal = direction === REFERENCE_LINE_DIRECTION.HORIZONTAL;

    const tooltipStyle = isHorizontal
        ? {
              left: clamp(tooltipPosition.x, containerRect.left + 30, containerRect.right + 30),
              top: clamp(tooltipPosition.y, containerRect.top + 50, containerRect.bottom),
          }
        : {
              left: clamp(tooltipPosition.x, containerRect.left, containerRect.right),
              top: clamp(tooltipPosition.y, containerRect.top + 20, containerRect.bottom - 20),
          };

    const isOverViewPort = isVertical
        ? tooltipPosition.x > containerRect.right || tooltipPosition.x < containerRect.left + rulerBarSize
        : tooltipPosition.y > containerRect.bottom || tooltipPosition.y < containerRect.top + rulerBarSize;
    const isOverTop = isHorizontal && tooltipPosition.y < containerRect.top + rulerBarSize;
    const positionIno = isHorizontal ? `Y: ${Math.round(position)}` : `X: ${Math.round(position)}`;

    const tooltipContent = isOverViewPort ? $t((v) => v.navigatorLayer.releaseToDelete) : positionIno;

    return (
        <div
            className={classnames('l-reference-line__tooltip', {
                ['l-reference-line__tooltip_vertical']: isVertical,
                ['l-reference-line__tooltip_horizontal']: isHorizontal,
                ['l-reference-line__tooltip_horizontal__over-top']: isOverTop,
            })}
            style={tooltipStyle}
        >
            {tooltipContent}
        </div>
    );
};

export default PositionTip;
